import {BaseDataProvider} from "./BaseDataProvider";
import {SurveySelectionListOptions} from "../model/SurveySelectionListOptions";
import {SurveySelectionModel} from "../model/SurveySelectionModel";
import {BaseDataProviderAgent} from "./BaseDataProviderAgent";

export class SurveySelectionDataProvider
    extends BaseDataProvider<SurveySelectionModel, SurveySelectionListOptions> {

    constructor() {
        super(`/survey/selections`);
    }

    getInsertData = (data: SurveySelectionModel): any => {
        const req = {...data} as any;
        delete req.id;
        delete req.createdAt;
        delete req.startedAt;
        delete req.finishedAt;
        delete req.countIncluded;
        delete req.state;
        if (data.conditions) {
            for (const cond of data.conditions) {
                (cond as any).campaignId = cond.campaign.id;
                delete cond.campaign;
                delete cond.form;
                delete (cond as any).id;
                for (const ans of cond.answers) {
                    (ans as any).questionId = ans.question?.id;
                    delete ans.question;
                    delete (ans as any).id;
                }
            }
        }
        return req;
    }


    getUpdateData = (id: string, data: SurveySelectionModel): any => {
        return this.getInsertData(data);
    }

    mapModel = (model: any): SurveySelectionModel => {
        const result = {...model};
        //result.conditions?.forEach((condition: any) => { condition.id = result.conditions.indexOf(condition) + 1})
        return result;
    }

    execute = async (id: string) => {
        await BaseDataProviderAgent.send(
            'post',
            `${this.baseUrl}/execute/${id}`);
    }

}